import { createClient } from '@supabase/supabase-js'


const SUPABASE_URL = 'https://jluluiukgtasntclarrm.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpsdWx1aXVrZ3Rhc250Y2xhcnJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTM1MTY5ODQsImV4cCI6MjAwOTA5Mjk4NH0.9d3boy3olUqJz_Bbv7RoHXyfgXoaNjoJmATEa99O05g'


const supabaseUrl = SUPABASE_URL
const supabaseAnonKey = SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 